import './styles/common/common.scss';
import './styles/site.scss';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';
import 'pickadate/lib/picker.js';
import 'pickadate/lib/picker.date.js';
import 'magnific-popup';
import 'select2';
import 'tooltipster';
import 'imprintjs/dist/imprint.js';
import 'jquery-number/jquery.number.js';
import './scripts/common/plugins/jquery.accordion.js';
import './scripts/common/plugins/jquery.auto-focus.js';
import './scripts/common/plugins/jquery.cookie-policy.js';
import './scripts/common/plugins/jquery.dropdown.js';
import './scripts/common/plugins/jquery.include.js';
import './scripts/common/plugins/jquery.instalment-navigator.js';
import './scripts/common/plugins/jquery.modals.js';
import './scripts/common/plugins/jquery.offer-inputcard.js';
import './scripts/common/plugins/jquery.scroll-top.js';
import './scripts/common/plugins/jquery.sticky-header.js';
import './scripts/common/plugins/jquery.time-converter.js';
import './scripts/plugins/payment/jquery.payment-adjustment.js';
import './scripts/plugins/jquery.debts.js';
import './scripts/plugins/jquery.paysteps-navigator.js';
import './scripts/plugins/jquery.paysteps.js';
import './scripts/plugins/jquery.totals.js';
import './scripts/common/app.js';
import './scripts/common/helpers.js';
import './scripts/common/plugins.js';
import './scripts/common/init.js';
import './scripts/plugins.js';
import './scripts/common/options.js';
import './scripts/init.js';
import './scripts/common/viewlisteners/base/base.viewlistener.js';
import './scripts/common/viewlisteners/global/announcement.viewlistener.js';
import './scripts/common/viewlisteners/global/popup-extension.viewlistener.js';
import './scripts/common/viewlisteners/global/session.viewlistener.js';
import './scripts/viewlisteners/account/account.viewlistener.js';
import './scripts/viewlisteners/account/accountSelector.viewlistener.js';
import './scripts/viewlisteners/affordability/affordability.viewlistener.js';
import './scripts/viewlisteners/auth/auth.viewlistener.js';
import './scripts/viewlisteners/budgetCalculator/budgetCalculator.viewlistener.js';
import './scripts/viewlisteners/budgetCalculator/incomeExpenditureForm.js';
import './scripts/viewlisteners/easypaypayment/easypay-payment.viewlistener.js';
import './scripts/viewlisteners/errors/errors.viewlistener.js';
import './scripts/viewlisteners/help/complaints.viewlistener.js';
import './scripts/viewlisteners/help/consent.viewlistener.js';
import './scripts/viewlisteners/help/contact.viewlistener.js';
import './scripts/viewlisteners/home/home.viewlistener.js';
import './scripts/viewlisteners/marketing-preferences/marketing-preferences.js';
import './scripts/viewlisteners/payment/payment-status.viewlistener.js';
import './scripts/viewlisteners/payment/payment.viewlistener.js';
import './scripts/viewlisteners/planexplorer/planexplorer.viewlistener.js';
import './scripts/viewlisteners/preferences/preferences.viewlistener.js';
import './scripts/viewlisteners/profile/profile.viewlistener.js';
import './scripts/viewlisteners/registration/preregistration.js';
import './scripts/viewlisteners/registration/registration.js';
import './scripts/viewlisteners/securepayment/securepayment-status.viewlistener.js';
import './scripts/viewlisteners/security-challenge/security-challenge.viewlistener.js';
import './scripts/viewlisteners/shared/shared.viewlistener.js';
import './scripts/viewlisteners/transactionHistory/transactionHistory.js';
$(function () {
  app.init();
});